module.exports = __webpack_public_path__ + "static/images/txcz-wx-code.747b9d9.png";